export const languageFromPath = (pathname) => {
  if (pathname === '/en' || pathname.startsWith('/en/')) return 'en';
  return 'de';
};

export const stripLocale = (pathname) => {
  if (!pathname || pathname === '/en' || pathname === '/en/') return '/';
  if (pathname.startsWith('/en/')) return pathname.slice(3) || '/';
  return pathname;
};

export const localizePath = (path, language) => {
  if (typeof path !== 'string' || !path.startsWith('/')) return path;

  const hashIndex = path.indexOf('#');
  const queryIndex = path.indexOf('?');
  let splitAt = path.length;
  if (hashIndex >= 0) splitAt = Math.min(splitAt, hashIndex);
  if (queryIndex >= 0) splitAt = Math.min(splitAt, queryIndex);

  const pathname = path.slice(0, splitAt) || '/';
  const suffix = path.slice(splitAt);
  const bare = stripLocale(pathname);

  if (language === 'en') {
    const prefixed = bare === '/' ? '/en' : `/en${bare}`;
    return prefixed + suffix;
  }

  return bare + suffix;
};
